import * as React from 'react';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import Text from '../Text/Text';
import avatarColors from './avatarColors';
import './Avatar.css';

const { useMemo } = React;

export interface Props extends FlexProps {
  name: string;
  url?: string;
  size?: string;
}

const Avatar: React.FunctionComponent<Props> = (props: Props) => {
  const { url, name, size = '2rem', ...rest } = props;

  const memoizedValue = useMemo(() => {
    if (!url) {
      const str = name.toUpperCase();
      const shortHand = `${str.charAt(0)}${str.charAt(str.length - 1)}`;
      const seed = str.charCodeAt(0) + str.charCodeAt(str.length - 1);

      return {
        shortHand: shortHand,
        styles: {
          backgroundColor: avatarColors[seed % avatarColors.length],
        },
      };
    }

    return {
      shortHand: null,
      styles: {
        backgroundImage: `url(${url})`,
      },
    };
  }, [url]);

  return (
    <Flex
        borderRadius="rounded"
        { ...rest }
        alignChildrenHorizontal="middle"
        alignChildrenVertical="middle"
        className="Avatar"
        direction="horizontal"
        height={ size }
        overflow="hidden"
        style={ { ...memoizedValue.styles, ...rest.styles } }
        width={ size }>
      <Flex>
        { memoizedValue.shortHand && (
          <Text config="7" textColor="white">
            { memoizedValue.shortHand }
          </Text>
        ) }
      </Flex>
    </Flex>
  );
};

export default Avatar;
